// @flow

import { Field } from 'react-form';
import { Select } from 'semantic-ui-react';
import React from 'react';

type Props = {
  onChange: (val: string) => void,
  field: string,
  options: Array<any>,
  validate: Function
};

const CustomSelect = (props: Props) => {
  const { onChange, field, validate, options, ...rest } = props;

  return (
    <Field validate={validate} field={field}>
      {fieldApi => {
        const { value, setValue } = fieldApi;

        return (
          <Select
            {...rest}
            options={options}
            value={value || ''}
            onChange={(e, data) => {
              setValue(data.value);

              if (onChange) {
                onChange(data.value);
              }
            }}
          />
        );
      }}
    </Field>
  );
};

export default CustomSelect;



// WEBPACK FOOTER //
// ./src/forms/Select.js